// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.109.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.109.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yO8FhS9XgOUxG6VbHL3Q{display:flex;flex-direction:column;row-gap:.5rem;margin-top:.5rem;width:100%}`, "",{"version":3,"sources":["webpack://./src/pages/tl25/components/MatchList.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,qBAAA,CACA,aAAA,CACA,gBAAA,CACA,UAAA","sourcesContent":[".list {\n  display: flex;\n  flex-direction: column;\n  row-gap: 0.5rem;\n  margin-top: 0.5rem;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `yO8FhS9XgOUxG6VbHL3Q`
};
export default ___CSS_LOADER_EXPORT___;
